export const visitationTeamAreaPathName = 'visitationsteam';
